import DOMPurify from "dompurify";

export interface SanitizeResult {
  sanitized: string;
  error: string | null;
}

export const sanitizeHtml = (html: string): SanitizeResult => {
  try {
    // Create a custom DOMPurify configuration that preserves CSS
    const customConfig = {
      WHOLE_DOCUMENT: true,
      ALLOWED_TAGS: [
        // Document structure
        "html", "head", "body", "title", "meta",
        // Content tags
        "p", "div", "span", "h1", "h2", "h3", "h4", "h5", "h6",
        "strong", "em", "i", "b", "u", "ul", "ol", "li", "br", "hr",
        "a", "img", "table", "tr", "td", "th", "thead", "tbody", "tfoot",
        "pre", "code", "blockquote",
        // CSS and styling
        "style", "link",
      ],
      ALLOWED_ATTR: [
        "href", "src", "alt", "title", "class", "id", "style",
        // Data attributes for responsive tables
        "data-label", "data-*",
        // Meta attributes
        "charset", "name", "content", "viewport", "lang",
        // Link attributes for CSS
        "rel", "type", "media",
      ],
      ALLOW_DATA_ATTR: true,
      FORBID_TAGS: ["script", "object", "embed", "form", "input", "button"],
      FORBID_ATTR: ["onclick", "onload", "onerror", "onmouseover"],
      KEEP_CONTENT: true,
      ALLOW_ARIA_ATTR: true,
      ALLOW_UNKNOWN_PROTOCOLS: false,
    };

    // Hook to preserve style tag content
    DOMPurify.addHook("beforeSanitizeElements", function (node) {
      if (node.nodeName === "STYLE") {
        node.textContent = node.textContent; // Preserve style content
      }
    });

    const sanitized = DOMPurify.sanitize(html, customConfig);

    // Remove the hook after use to avoid affecting other calls
    DOMPurify.removeAllHooks();

    return {
      sanitized,
      error: null,
    };
  } catch (error) {
    return {
      sanitized: "",
      error: `HTML sanitization failed: ${error instanceof Error ? error.message : "Unknown error"}`,
    };
  }
};
